import { useFeatureEntitlements } from "@frontegg/react";
import { useBrandingContext } from "context/BrandingContext";
import CardIssuer from "enums/CardIssuer";

/**
 * Whether out-of-pocket reimbursements are available to this tenant.
 *
 * Both halves are load-bearing: the entitlement is sold separately, and only
 * Stripe issuing can pay a reimbursement out, so a Highnote tenant with the
 * entitlement still cannot use the feature.
 */
export const useShowReimbursements = (): boolean => {
  const { platform } = useBrandingContext();
  const { isEntitled: featureOutOfPocket } = useFeatureEntitlements(
    "feature_out_of_pocket",
  );

  return platform.cardIssuer === CardIssuer.STRIPE && featureOutOfPocket;
};

export default useShowReimbursements;
